import { useFeatureLoyaltyUiOptInModalQuery } from 'generated/sanity-graphql';
import { useFeaturesContext } from 'state/features';

export const useFeaturesLoyaltyOptInModal = () => {
  const { featureLoyaltyUIId = '', featureIdsLoading } = useFeaturesContext();
  const { data, loading } = useFeatureLoyaltyUiOptInModalQuery({
    variables: { featureLoyaltyUIId },
    skip: !featureLoyaltyUIId,
  });

  return {
    data: data?.LoyaltyUI,
    loading: featureIdsLoading || loading,
  };
};
